<template>
  <div
    :class="{ 'h5-promotion-video': isH5, 'pc-promotion-video': !isH5 }"
    class="promotion-video"
  >
    <!-- <p class="content-title">{{ moduleInfo.module_title }}</p> -->
    <div
      class="video-item"
      v-for="item in moduleInfo.content_list"
      :key="item.id"
    >
      <div class="video-wrap">
        <div v-show="!item.playVideo">
          <!-- 蒙层 -->
          <div class="layer-wrap"></div>
          <img
            class="video-cover"
            :src="item.cover_url + '?imageView2/0/w/1000'"
            alt=""
          />
          <img
            @click="initDplay(item)"
            class="play-btn"
            src="../../../assets/images/video-play.png"
            alt=""
          />
        </div>
        <!-- 播放器 -->
        <div v-show="item.playVideo" :id="'dplayer-' + item.id"></div>
      </div>
      <div class="video-info">
        <p class="title">{{ item.title }}</p>
        <p class="desc">{{ item.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  props: {
    moduleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
    };
  },
  methods: {
    initDplay(item) {
      this.$set(item, "playVideo", true);
      item.dp = new window.DPlayer({
        container: document.getElementById("dplayer-" + item.id),
        video: {
          url: item.video_url,
        },
      });
      item.dp.play();
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-promotion-video {
  // .content-title {
  //   margin-bottom: 24px;
  // }
  .video-item {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    .video-wrap {
      position: relative;
      width: 100%;
      height: 450px;
      border-radius: 24px;
      .play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 50px;
        height: 50px;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 2;
      }
      .layer-wrap {
        z-index: 1;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 24px;
        left: 0;
        top: 0;
        background-color: rgba($color: #000000, $alpha: 0.4);
      }
      .video-cover {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 24px;
      }
      & > div {
        width: 100%;
        height: 100%;
      }
    }
    .video-info {
      margin: 12px 10px 0;
      .title {
        font-weight: 500;
        font-size: 24px;
        color: var(--text-primary, #0d1400);
        line-height: 33px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 8px;
      }
      .desc {
        font-weight: 400;
        font-size: 16px;
        color: var(--text-secondary, #515350);
        line-height: 22px;
      }
    }
  }
}

.h5-promotion-video {
  // .content-title {
  //   margin-bottom: 0.43rem;
  // }
  .video-item {
    margin-bottom: 0.27rem;
    &:last-child {
      margin-bottom: 0;
    }
    .video-wrap {
      position: relative;
      width: 100%;
      height: 5.25rem;
      border-radius: 0.32rem;
      .play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 1.07rem;
        height: 1.07rem;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 2;
      }
      .layer-wrap {
        z-index: 1;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 0.32rem;
        left: 0;
        top: 0;
        background-color: rgba($color: #000000, $alpha: 0.2);
      }
      .video-cover {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0.32rem;
      }
      & > div {
        width: 100%;
        height: 100%;
      }
    }
    .video-info {
      margin-top: 0.16rem;
      .title {
        margin-bottom: 0.13rem;
        font-weight: 500;
        font-size: 0.4rem;
        color: var(--text-primary, #0d1400);
        line-height: 0.56rem;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .desc {
        font-weight: 400;
        font-size: 0.29rem;
        color: var(--text-secondary, #515350);
        line-height: 0.4rem;
      }
    }
  }
}
</style>
